import styled from 'styled-components'
import { Borders, Colors } from '../constants'

export const OptionButton = styled.button`
  padding: 2px 6px;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  text-transform: uppercase;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
  background: transparent;
  cursor: pointer;
  outline: none;

  &:focus,
  &:hover {
    color: ${Colors.Hover};
    border-color: ${Colors.Hover};
  }
`
